<template>
  <div class="b-field-title">{{ attributes.title }}</div>
  <div :class="[fieldName, hasError ? 'container-error' : '']" class="input-container">
    <input
        :class="{'input-error': hasError}"
        class="b-fluid"
        :type="type"
        :placeholder="attributes.placeholder"
        :value="form[fieldName]"
        @blur="$emit('run-validate', fieldName)"
        @input="$emit('input', {e: {[fieldName]: $event.target.value.trim()}, fieldName})"
    >
  </div>
  <div
      v-if="attributes.description"
      v-html="attributes.description"
      class="form-caption"
  ></div>
  <div v-if="hasError" class="form-caption form-error-message">
    <div v-for="error in formErrors[fieldName].$errors" :key="error">
      {{ error.$message }}
    </div>
  </div>
</template>

<script>
import {useStore, mapGetters} from 'vuex';

export default {
  name: 'FormInput',
  props: {
    fieldName: {
      type: String,
      required: true,
    },
    formErrors: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      default: () => 'text',
    },
  },
  emits: ['input', 'run-validate'],
  setup() {
    const store = useStore();

    return {
      store
    };
  },
  computed: {
    ...mapGetters([
      'form',
      'formAttrs',
    ]),
    attributes() {
      return this.formAttrs[this.fieldName];
    },
    hasError() {
      return this.formErrors[this.fieldName].$error;
    },
  },
};
</script>

<style scoped>
input {
  padding: 8px 12px;
}
</style>
